/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { allCorporateClients } from "../../../data/Axios/queries";
import { clientManagementUrl } from "../../../config";
import { CorporateClientsColumns } from "../../../data/DynamicTable/Collumns";
import CorporateClientsForm from "./form";
import { UploadDocumentComponent } from "../../../data/DynamicTable/Modal";
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { downloadCorporateClientFile } from "../../../data/DynamicTable/DynamicFunctions";
import { CloudUploadIcon } from "lucide-react";

const base_url = clientManagementUrl.uri;
const actions = {
  entity: "Corporate Clients",
  required: "id",
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },

  ViewCorporateClientCases: {
    key: "ViewCases",
    button_name: " Files 360",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    inputObjectName: "bulkActivateDeactivateCorporateClients",
  },
    EngagementLetter: {
    key: "EngagementLetter",
    button_name: " Engagement Letter",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
   viewJournalEntries: { // New action for journal entries
    key: "VIEW_JOURNAL_ENTRIES",
    button_name: "View Journal Entries",
   Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    query: "anyCorparateJournalLinesByColumnValues", // Query to fetch journal entries
    inputFields: (row) => ({ 
      identifierId: row.id,
      cancelled: null,
    }),
    returnFields: [
      "journalLineID",
      "journalEntryID",
      "accountID",
      "debit",
      "credit",
      "description",
      "createdDate",
      "caseId",
      "applicationId",
      "applicationType",
    ],
  },


  dataObject: {
    inputFields: {
      isActive: null,
    },
    inputObjectName: "allCorporateClients",
    inputSubObjectName: "clientModel",
    returnFields: [
      "id",
      "contactNumber",
      "email",
      "address",
      "dateAdded",
      "notes",
      "companyName",
      "registrationNumber",
      "industrySector",
      "contactPersonName",
      "contactPersonPosition",
      "contactPersonEmail",
      "contactPersonPhone",
      "companyAddress",
      "billingAddress",
      "incorporationDate",
      "legalStructure",
      "countryOfIncorporation",
      "taxIdentificationNumber",
      "authorizedSignatoryName",
      "authorizedSignatoryPosition",
      "authorizedSignatoryEmail",
      "authorizedSignatoryPhone",
      "accountBalance",
      "isActive",
      "statusFlag",
      "createdBy",
      "createdDate",
      "updatedBy",
      "updatedDate",
      "companyId",
      "company",
      "regionId",
      "branchId",
    ],
  },
};
function CorporateClients() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleOpenModal = () => {
    setDialogOpen(true);
  };
  const handleDownload = async () => {
    await downloadCorporateClientFile();
  };

  return (
    <Box m="2px">
      <Box
        m="2px"
        sx={{
          justifyContent: "end",
          alignItems: "center",
          display: "flex",
        }}
      >
        <Typography style={{ color: colors.greenAccent[400], margin: "0 8px" }}>
          Import Corporate Clients(s)
        </Typography>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUploadIcon />}
          sx={{
            backgroundColor: colors.greenAccent[500],
            borderRadius: "4px",
            m: "10px",
          }}
          onClick={handleOpenModal}
        >
          <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
            Import
          </Typography>
        </Button>
      </Box>
      <DynamicTable
        title="Corporate Clients"
        subtitle="View all Corporate Clients, create edit or view details"
        columns={CorporateClientsColumns}
        FormComponent={CorporateClientsForm}
        //query={allCorporateClients}
        base_url={base_url}
        actions={actions}
        //entity="Corporate Clients"
      />
      <UploadDocumentComponent
        uploadType="corporateClients"
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </Box>
  );
}

export default CorporateClients;
